var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwakenShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 486,
    viewBox: "0 0 548 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.693 30.3788C321.706 -3.15143 235.852 -36.5987 92.322 92.8789C-131.466 299.553 100.908 520.985 268.95 481.361C393.367 452.023 515.495 449.906 543.707 332.668C565.162 243.509 504.247 70.6034 404.693 30.3788Z",
    fill: "#EEE8DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwakenShape);
export default __webpack_public_path__ + "static/media/awaken-shape.20e0722462c46e4b527ed1e5b0ab555d.svg";
export { ForwardRef as ReactComponent };